























































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { debounce } from 'lodash';
import { Watch } from 'vue-property-decorator';

import User from '../../types/user/user';
import Header from '../../types/app/header';
import UserHeader from '../../types/app/userHeader';

import Endpoint from '../../utils/endpoint';

@Component({})
export default class IndexUser extends Vue {
  @Getter('getUser', { namespace: 'auth' }) user!: User;

  headers: Array<Header> = UserHeader.header;

  debounceSearch: any = null;
  users: Array<User> = [];
  loading = false;
  gettingApplications = true;
  filter = {
    search: ''
  };

  async created() {
    this.debounceSearch = debounce(this.getUsers, 1000);
    await this.getUsers();
  }

  @Watch('filter.search')
  private async filtering() {
    if (this.filter.search != null) {
      this.users = [];
      this.debounceSearch();
    }
  }

  async getUsers(): Promise<void> {
    try {
      this.loading = true;
      const resp: any = await this.$http.get(`${Endpoint.Url.user.index}?query=${this.filter.search}`);

      console.log('profiles', JSON.parse(JSON.stringify(resp)));

      if (resp.statusCode.item1 === 200) {
        this.users = resp.data;
      }
      this.loading = false;
    } catch (error) {
      this.loading = false;
      console.log('error', error);
    }
  }

  goToDetail(item: any): void {
    this.$router.push({ name: 'FormUser', params: { id: item.id } });
  }
}
